module.exports = __webpack_public_path__ + "static/img/nav011.80f13b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/index/nav011.png
// module id = D0K2
// module chunks = 1